<template>
  <main class="calendar">
    <div class="background">
      <background-vector :alpha="0.15" :scale="background.scale" :viewbox="background.viewbox" :rotate="75" class="calendar__vector"/>
      <h3 class="background__banner calendar__banner">{{ content.banner }}</h3>
    </div>

    <div class="calendar__content">
      <router-view/>
    </div>

    <header-nav/>
    <footer-nav :sidebars="sidebars"/>
  </main>
</template>

<script>
import metaData from '../../mixins/meta-data'

export default {
  name: 'events',
  mixins: [metaData],

  data() {
    return {
      sidebars: {
        left: { to: '/blogue', modifier: 'fill' }
      }
    }
  },

  computed: {
    content() { return this.$store.state.content.calendar },
    mobile() { return this.$media.mobile },
    background() {
      return {
        scale: (this.mobile) ? 2 : null,
        viewbox: {
          offsetX: (this.mobile) ? 300 : -700,
          offsetY: (this.mobile) ? 75 : -200
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Events.vue?396f78be